import { render } from "./Asset_Units.vue?vue&type=template&id=acd2bb98"
import script from "./Asset_Units.vue?vue&type=script&lang=js"
export * from "./Asset_Units.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__